import "./index.scss";
import "app/i18n";

import { Spinner } from "@ab.uitools/ui-library/components/Spinner";
import { App } from "app";
import { store } from "app/store";
import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <Suspense fallback={<Spinner size="large"/>}>
        <App/>
      </Suspense>
    </Provider>
  </StrictMode>,
);
